import React from 'react';
// import { useSnap } from '../../store'
// import toast from 'react-hot-toast';


function Turkishtos2() {
  return (
    <div className="space-y-10 text-slate-800">
      {/* Turkish Section */}
      <section className="space-y-6" lang="tr">
        <div className="text-center space-y-2">
          <h2 className="text-lg font-bold text-slate-900 uppercase tracking-tight">
            Kişisel Verilerin Korunması Kanunu Çerçevesinde
          </h2>
          <h3 className="text-base font-semibold text-slate-700">
            Global Assessment Eğitim ve Danışmanlık Tic. Ltd. Şti. Eğitim Alanlar İçin Verilerinin İşlenmesine İlişkin Aydınlatma Metni
          </h3>
        </div>

        <div className="space-y-4 text-sm leading-relaxed sm:text-base">
          <p>
            Global Assessment Eğitim ve Danışmanlık Tic. Ltd. Şti. (Global Assessment) Veri Sorumlusu Sıfatıyla; kişisel verilerinizin korunmasına ve güvenliğine önem göstermekte, bu sebeple de başta özel hayatın gizliliği olmak üzere kişisel verilerin korunması amacıyla düzenlenen 6698 sayılı Kişisel Verilerin Korunması Kanunu ve ilgili diğer mevzuat hükümleri uyarınca kişisel verilerinizin toplanma şekilleri, işlenme amaçları, işlemenin hukuki nedenleri, işbu verilerin kimlere hangi amaçla aktarıldığı ve bu konudaki haklarınıza ilişkin olarak, sizleri KVKK kapsamındaki aydınlatma yükümlülüğümüz çerçevesinde bilgilendirmek isteriz.
          </p>

          <div className="space-y-2">
            <h4 className="font-bold border-b pb-1">1. Kişisel Verilerin Toplanma Yöntemi ve Hukuki Sebebi</h4>
            <p>
              Şirketimiz, eğitim alanların verilerini kanun gereğince aşağıda sayılan kanallar vasıtasıyla, tamamen veya kısmen otomatik ya da veri kayıt sisteminin parçası olmak kaydıyla otomatik olmayan yollarla, sözlü, yazılı veya elektronik şekilde kanuna uygun olarak toplamakta ve Kanunun 5’ inci ve 6’ ıncı maddelerinde belirtilen kişisel veri işleme şartları ve amaçları dâhilinde bu metnin c ve d bendinde belirtilen amaçlarla işleyebilmekte ve aktarabilmektedir.
            </p>
            <ul className="list-disc pl-5 space-y-1">
              <li><span className="font-semibold underline">Kişisel Veriler:</span> İletişim Bilgisi (Telefon numarası, e-posta adresi), Görsel ve İşitsel Bilgi (Fotoğraf, kamera kayıtları, okul bünyesinde gerçekleştirilen etkinliklerin / projelerin bilgi ve fotoğraf kayıtları)</li>
              <li><span className="font-semibold underline">Özel Nitelikli Kişisel Veriler:</span> Sağlık Bilgisi (Hastalık ve alerji bilgileri, gelişim bilgileri, sağlık bilgisi), Biyometrik ve Genetik Bilgi (Kan grubu)</li>
            </ul>
          </div>

          <div className="space-y-2">
            <h4 className="font-bold border-b pb-1">2. Kişisel Verilerin İşlenme Amaçları</h4>
            <p>Kişisel verileriniz Global Assessment tarafından aşağıdaki amaçlar dahilinde işlenmektedir:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li>Eğitim ve eğitim alanlar arasındaki ilişkilerin düzenlenmesi, planlanması ve memnuniyetin sağlanması,</li>
              <li>Yabancı dil mülakat hizmetinin online video, ses ve ekran görüntüsü olarak kaydedilmesi ve ilgili taraflarla paylaşımı,</li>
              <li>Aday kayıtlarının oluşturulması ve yönetilmesi,</li>
              <li>Yasal sınırlar içerisinde değerlendirme çalışmalarının yapılması,</li>
              <li>Hizmet şartlarındaki değişiklikler hakkında bilgilendirme yapılması,</li>
              <li>Hukuki ve ticari güvenliğin temini,</li>
              <li>Şikayetlerin çözülmesi ve veri erişim/düzeltme taleplerinin işleme alınması,</li>
              <li>Bilgi güvenliği süreçlerinin ve BT altyapısının yönetilmesi,</li>
              <li>Yasal hakların savunulması ve hukuki süreçlerin takibi,</li>
              <li>İş ortakları ve tedarikçilerle olan ilişkilerin yönetimi,</li>
              <li>Kalite ve gizlilik standartlarının denetimi.</li>
            </ul>
          </div>

          <div className="space-y-2">
            <h4 className="font-bold border-b pb-1">3. Kişisel Verilerin Kimlere ve Hangi Amaçla Aktarılabileceği</h4>
            <p>
              Kişisel verileriniz; kanuni yükümlülüklerin yerine getirilmesi amacıyla MEB, SGK gibi otoritelerle, yargı mercileriyle, tedarikçilerimizle ve iş ortaklarımızla paylaşılabilecektir. Veri aktarımı sırasında gerekli teknik ve hukuki önlemler alınmaktadır.
            </p>
          </div>

          <div className="space-y-2">
            <h4 className="font-bold border-b pb-1">4. Kişisel Veri Sahibinin Hakları</h4>
            <p>KVKK’nın 11. Maddesi uyarınca haklarınız:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li>Verilerinizin işlenip işlenmediğini öğrenme ve bilgi talep etme,</li>
              <li>İşlenme amacını ve amacına uygun kullanılıp kullanılmadığını öğrenme,</li>
              <li>Yurt içinde veya yurt dışında aktarıldığı üçüncü kişileri bilme,</li>
              <li>Eksik veya yanlış işlenmişse düzeltilmesini isteme,</li>
              <li>Kanuna uygun olarak silinmesini veya yok edilmesini talep etme,</li>
              <li>Zarara uğranması halinde zararın giderilmesini talep etme.</li>
            </ul>
          </div>
        </div>
      </section>

      <div className="border-t border-slate-200" />

      {/* English Section */}
      <section className="space-y-6" lang="en">
        <div className="text-center space-y-2">
          <h2 className="text-lg font-bold text-slate-900 uppercase tracking-tight">
            Within the framework of the Personal Data Protection Law
          </h2>
          <h3 className="text-base font-semibold text-slate-700">
            Global Assessment Education and Consulting Trade. Ltd. Sti. Illumination Text Regarding the Processing of Data for Trainees
          </h3>
        </div>

        <div className="space-y-4 text-sm leading-relaxed sm:text-base">
          <p>
            Global Assessment Education and Consulting Trade. Ltd. Sti. (Global Assessment), as the Data Controller, attaches great importance to the protection and security of your personal data. In accordance with Law No. 6698 and other relevant legislation, we would like to inform you about the collection, processing, and transfer of your personal data.
          </p>

          <div className="space-y-2">
            <h4 className="font-bold border-b pb-1">1. Personal Data Collection Method and Legal Basis</h4>
            <p>
              Our company collects trainee data through various channels (verbal, written, or electronic) as part of our data recording systems, in accordance with Articles 5 and 6 of the Law.
            </p>
            <ul className="list-disc pl-5 space-y-1">
              <li><span className="font-semibold underline">Personal Data:</span> Contact info (phone, email), Visual/Audio info (photos, camera recordings, school project records).</li>
              <li><span className="font-semibold underline">Special Categories:</span> Health info (illness, allergy, development info), Biometric/Genetic info (blood type).</li>
            </ul>
          </div>

          <div className="space-y-2">
            <h4 className="font-bold border-b pb-1">2. Purposes of Processing Personal Data</h4>
            <p>Your data is processed for the following purposes:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li>Organizing training relations and ensuring trainee satisfaction,</li>
              <li>Recording and sharing foreign language interviews (video/audio) with relevant parties,</li>
              <li>Candidate record management,</li>
              <li>Evaluation within legal limits,</li>
              <li>Providing updates on terms of service,</li>
              <li>Ensuring legal and commercial security,</li>
              <li>Resolving complaints and processing data requests,</li>
              <li>Managing IT infrastructure and security processes,</li>
              <li>Defending legal rights and remedies,</li>
              <li>Managing relationships with partners and suppliers,</li>
              <li>Ensuring quality and privacy standards.</li>
            </ul>
          </div>

          <div className="space-y-2">
            <h4 className="font-bold border-b pb-1">3. Transfer of Personal Data</h4>
            <p>
              Data may be transferred to authorized public institutions (Ministry of National Education, Social Security Institution), judicial authorities, and business partners/suppliers for legal compliance and service delivery.
            </p>
          </div>

          <div className="space-y-2">
            <h4 className="font-bold border-b pb-1">4. Rights of the Data Owner</h4>
            <p>Under Article 11 of the KVKK, you have the right to:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li>Learn if data is processed and request information,</li>
              <li>Learn the purpose of processing,</li>
              <li>Know the third parties to whom data is transferred,</li>
              <li>Request correction of incomplete or incorrect data,</li>
              <li>Request deletion or destruction of data,</li>
              <li>Object to results from automated systems,</li>
              <li>Claim compensation for damages caused by unlawful processing.</li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
}



export default Turkishtos2